import React, { useEffect, useRef, useState, useCallback } from "react";

const galleryImages = [
  { src: "/img/p1.jfif", alt: "Gurunathan Electronics shop signboard" },
  { src: "/img/p2.jfif", alt: "Shop shelf with electrical stock" },
  { src: "/img/p3.jfif", alt: "Shop interior view" },
  { src: "/img/p4.jfif", alt: "Weighing scales display" },
  { src: "/img/p5.jfif", alt: "Audio equipment shelf" },
  { src: "/img/g2.mp4", alt: "Shop building exterior, Usilampatti Road" },
  { src: "/img/p14.jfif", alt: "Audio equipment shelf" },
  { src: "/img/p13.jpg", alt: "Audio equipment shelf" },
  { src: "/img/b1.png", alt: "Audio equipment shelf" },
];

const AUTOPLAY_MS = 3000;

export const Gallery = (props) => {
  const sectionRef = useRef(null);
  const trackRef = useRef(null);
  const timerRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(3);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const updateCards = () => {
      if (window.innerWidth <= 600) setCardsPerView(1);
      else if (window.innerWidth <= 991) setCardsPerView(2);
      else setCardsPerView(4);
    };
    updateCards();
    window.addEventListener("resize", updateCards);
    return () => window.removeEventListener("resize", updateCards);
  }, []);

  const maxIndex = galleryImages.length - 1;

  const goNext = useCallback(() => {
    setCurrent((c) => (c === maxIndex ? 0 : c + 1));
  }, [maxIndex]);

  const goPrev = useCallback(() => {
    setCurrent((c) => (c === 0 ? maxIndex : c - 1));
  }, [maxIndex]);

  useEffect(() => {
    if (paused) return;
    timerRef.current = setInterval(goNext, AUTOPLAY_MS);
    return () => clearInterval(timerRef.current);
  }, [goNext, paused]);

  const extended = [...galleryImages, ...galleryImages, ...galleryImages];
  const offset = galleryImages.length + current;

  return (
    <section id="gallery" ref={sectionRef} className={visible ? "in-view" : ""}>
      <div className="container">
        <div className="section-title">
          <div className="about-eyebrow">Take A Look</div>
          <h2>
            <span>Gallery</span>
          </h2>
          <hr style={{ margin: "0 auto 20px" }} />
          <p>A peek inside our shop on Usilampatti Road, Peraiyur.</p>
        </div>

        <div
          className="gallery-carousel"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          <button className="gallery-arrow gallery-arrow-left" onClick={goPrev} aria-label="Previous">
            <i className="fa fa-angle-left"></i>
          </button>

          <div className="gallery-viewport">
            <div
              ref={trackRef}
              className="gallery-track"
              style={{
                transform: `translateX(-${(offset / extended.length) * 100}%)`,
                width: `${extended.length * (100 / cardsPerView)}%`,
              }}
            >
              {extended.map((item, i) => (
                <div
                  className="gallery-card"
                  style={{ width: `${100 / extended.length}%` }}
                  key={i}
                >
                  {item.src.endsWith(".mp4") ? (
                    <video
                      ref={(el) => {
                        if (el) {
                          const isVisible = i >= offset && i < offset + cardsPerView;
                          if (isVisible && el.paused) {
                            el.play().catch(() => {});
                          } else if (!isVisible && !el.paused) {
                            el.pause();
                          }
                        }
                      }}
                      muted
                      loop
                      playsInline
                      preload="metadata"
                      poster="/img/p1.jfif"
                      style={{ width: "100%", display: "block" }}
                    >
                      <source src={item.src} type="video/mp4" />
                    </video>
                  ) : (
                    <img src={item.src} alt={item.alt} loading="lazy" />
                  )}
                </div>
              ))}
            </div>
          </div>

          <button className="gallery-arrow gallery-arrow-right" onClick={goNext} aria-label="Next">
            <i className="fa fa-angle-right"></i>
          </button>
        </div>

        <div className="gallery-dots">
          {galleryImages.map((_, i) => (
            <button
              key={i}
              className={`gallery-dot ${i === current ? "active" : ""}`}
              onClick={() => setCurrent(i)}
              aria-label={`Go to image ${i + 1}`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
};